import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../base/ui/components/web/Dialog';
/**
 * Dialog asking the user to confirm they want to leave the meeting from the
 * Picture-in-Picture hangup control.
 *
 * @returns {JSX.Element}
 */
export default function PipHangupConfirmDialog({ onSubmit }) {
    const { t } = useTranslation();
    return (React.createElement(Dialog, { onSubmit: onSubmit, title: t('dialog.pipLeaveMeetingConfirmTitle') },
        React.createElement("div", null, t('dialog.pipLeaveMeetingConfirm'))));
}
